import { Link } from "react-router-dom";
import WaveformMark from "@/components/WaveformMark";

export default function Footer() {
  return (
    <footer className="bg-ink-1 text-parchment relative overflow-hidden border-t border-white/[0.08]" data-testid="site-footer">
      <div className="container-edge py-20 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <WaveformMark className="w-8 h-8 text-parchment" />
              <span className="font-serif text-3xl">
                Voice<span className="text-rust">2</span>Evidence<sup className="text-[0.45em] align-super ml-0.5 text-muted-on-dark">™</sup>
              </span>
            </div>
            <p className="font-serif text-2xl leading-snug text-parchment/90 max-w-md">
              Voice → Evidence → Strategy. Turning patient voice into ready-to-act strategy — for every cross-functional team that depends on it.
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 mt-8 font-mono text-[11px] uppercase tracking-[0.22em] text-rust hover:text-terracotta transition-colors" data-testid="footer-cta-request">
              Request a Briefing →
            </Link>
          </div>

          <div className="md:col-span-2 md:col-start-7">
            <div className="eyebrow-muted mb-5">Practice</div>
            <ul className="space-y-3 text-sm text-parchment/80">
              <li><Link to="/practice" data-testid="footer-link-pillars" className="hover:text-rust transition-colors">Our Practice</Link></li>
              <li><Link to="/framework" data-testid="footer-link-framework" className="hover:text-rust transition-colors">PentaVoice™</Link></li>
              <li><Link to="/lifecycle" data-testid="footer-link-lifecycle" className="hover:text-rust transition-colors">Lifecycle</Link></li>
              <li><Link to="/perspective" data-testid="footer-link-perspective" className="hover:text-rust transition-colors">Perspective</Link></li>
              <li><Link to="/engagements" data-testid="footer-link-engagements" className="hover:text-rust transition-colors">Engagements</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="eyebrow-muted mb-5">Company</div>
            <ul className="space-y-3 text-sm text-parchment/80">
              <li><Link to="/about" data-testid="footer-link-about" className="hover:text-rust transition-colors">About</Link></li>
              <li><Link to="/about#methodology" data-testid="footer-link-methodology" className="hover:text-rust transition-colors">Methodology</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-rust transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="eyebrow-muted mb-5">Contact</div>
            <a
              href="mailto:enquiry@marksmanhealthcare.com"
              className="text-sm text-parchment/85 hover:text-rust transition-colors break-all"
              data-testid="footer-email-link"
            >
              enquiry@marksmanhealthcare.com
            </a>
            <div className="mt-6">
              <div className="eyebrow-muted mb-3">Designed with reference to</div>
              <ul className="space-y-2 text-sm text-parchment/80 font-mono uppercase tracking-[0.14em]">
                <li>ISPOR · MAPS</li>
                <li>AMCP · ISPE</li>
                <li>EU HTA / JCA</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="hairline mt-16" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mt-8">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-on-dark">
            © {new Date().getFullYear()} Voice2Evidence — Patient-centered evidence intelligence
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-on-dark/80">
            An AI-led, expert-validated services engagement by <span className="text-parchment">MarksMan Healthcare</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
